var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showConfirm
    ? _c(
        "confirm-auth",
        {
          attrs: {
            details: _vm.confirmDetails,
            error: _vm.error,
            "confirm-state": _vm.forgotPassConfirm
          },
          on: {
            "cancel-confirm": _vm.cancelConfirm,
            "submit-confirm": _vm.onConfirmSubmitted
          }
        },
        [
          _c("loading-spinner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ]
          })
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "auth-screen" },
        [
          _c("loading-spinner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ]
          }),
          _vm._v(" "),
          _c("h2", { staticClass: "mb-4" }, [
            _vm._v("\n    Reset Password\n  ")
          ]),
          _vm._v(" "),
          _c(
            "b-container",
            { staticClass: "auth-block has-border" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "user-emailid" } }, [
                        _vm._v("Email")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { id: "user-emailid", type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              $event.keyCode !== 13
                            ) {
                              return null
                            }
                            return _vm.onSubmitResetForm($event)
                          }
                        },
                        model: {
                          value: _vm.userName,
                          callback: function($$v) {
                            _vm.userName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "userName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex justify-content-end flex-no-wrap ml-3 mt-3 "
                    },
                    [
                      _vm.error
                        ? _c(
                            "div",
                            {
                              staticClass: "mr-4 alert alert-danger fade show",
                              attrs: { role: "alert" }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.error) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2 mr-2",
                          attrs: { title: "Cancel", disabled: _vm.loading },
                          on: { click: _vm.onCancel }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            title: "Reset Password",
                            disabled: _vm.userName === ""
                          },
                          on: {
                            click: _vm.onSubmitResetForm,
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                $event.keyCode !== 13
                              ) {
                                return null
                              }
                              return _vm.onSubmitResetForm($event)
                            }
                          }
                        },
                        [_vm._v("\n          Reset Password\n        ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 d-flex" }, [
            _vm._v("\n    Enter the email associated with this account. "),
            _c("br"),
            _vm._v(
              "\n    An authentication token will be sent to this email to reset the\n    password.\n  "
            )
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }